import type { RootState } from 'store'
import type { GetterTree } from 'vuex'
import type { UserState } from './types'

export const getters: GetterTree<UserState, RootState> = {
  user: (state: UserState) => state.user,
  users: (state: UserState) => state.users,
  total: (state: UserState) => state.users && state.users.length,
  authRole: (state: UserState) => state.user?.role,
  endUsers: (state: UserState) => state.endUsers,
  isTemporary: (state: UserState) => state.user?.isTemporary,
}
